import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import { LogoutFunction } from "../../../services/LogoutFunction";

export const updateJobFunc = createAsyncThunk(
  "update job func",
  async ({data , id}) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;

    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/carrers/update/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenData}`,
          // "Content-Type": "application/json",
        },
        body: data,
      }
    )
      .then((respons) => respons.json())
      .then((resulet) => {
        console.log(resulet);
        return resulet;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    return request;
  }
);
function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const updateJobSlicer = createSlice({
  name: "job/update",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(updateJobFunc.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateJobFunc.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      }
      if (action.payload.message === "Postion updated successfully") {
        state.data = action.payload;
        state.error = null;
      } else {
        state.data = null;
        state.error = action.payload.message;
      }
    });

    builder.addCase(updateJobFunc.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.payload.message;
    });
  },
});

export default updateJobSlicer.reducer;
